let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k2sUH")).then(() => parcelRequire('9Mhk9'));